import { useState } from 'react'
import useResizeObserver from 'use-resize-observer'
import { isOverflown } from 'lib/helpers/isOverflown/isOverflown'

export const useTruncationTooltip = (element: HTMLElement | null) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)

  const getIsTruncated = () => Boolean(element && isOverflown(element))

  // Relies on the element's width following its text until the row cuts it off, so late text also resizes it.
  useResizeObserver({ ref: element, onResize: () => setIsTruncated(getIsTruncated()) })

  const handleTooltipOpen = () => {
    setIsTooltipOpen(getIsTruncated())
  }

  const handleTooltipClose = () => {
    setIsTooltipOpen(false)
  }

  return { isTooltipOpen, isTruncated, handleTooltipOpen, handleTooltipClose }
}
